module.exports = __webpack_public_path__ + "static/mask-cta-33809a6091ed86098f30b787d6f8409e.png";